<template>
    <div class="col-12 col-lg-12 mb-3">
        <div class="card fitter shadow-sm" :class="[parseInt(fitter.average_score) == 5 ? 'five-star' : '', getCustomFitterClass(fitter.cal_account_number)]" :id="fitter.id">
            <!-- small devices and above header -->
            <div class="card-header rounded-0 border-0 p-0 d-none d-sm-flex text-left text-dark justify-content-between align-items-center">
                <span class="bg-mobile p-2 h-100" v-if="fitter.mobile == 1"><i class="fas fa-truck-fast mobile-fitter-icon"></i></span>
                <span class="p-2 h-100 marker-number cursor-pointer" :class="getCustomFitterClass(fitter.cal_account_number)" @click="highlightFitterOnMap()" v-else>{{ fitter.mapIconNumber }}</span>
                <h3 class="bg-gray text-dark p-2 m-0 text-capitalize me-auto d-block d-sm-inline-block" :class="{'cursor-pointer': fitter.mobile == 0 }" @click="fitter.mobile == 0 ? highlightFitterOnMap() : ''">
                    {{ fitter.name.toLowerCase() }}
                </h3>
                <div class="me-2">
                    <reviews :identifier="fitter.account_number" no-label></reviews>
                </div>
            </div>
            <!-- mobile header -->
            <div class="card-header rounded-0 border-0 p-0 d-flex d-sm-none text-left text-light">
                <div>
                    <span class="bg-mobile p-2 h-100" v-if="fitter.mobile == 1"><i class="fas fa-truck-fast mobile-fitter-icon"></i></span>
                    <span class="p-2 h-100 marker-number" :class="getCustomFitterClass(fitter.cal_account_number)" v-else>{{ fitter.mapIconNumber }}</span>
                    <h3 class="d-none d-sm-block bg-gray text-dark p-2 m-0 text-capitalize me-auto d-block d-sm-inline-block">{{ fitter.name.toLowerCase() }}</h3>
                </div>
                <div class="me-2">
                    <h3 class="d-block d-sm-none bg-gray text-dark p-2 m-0 text-capitalize me-auto d-block d-sm-inline-block">{{ fitter.name.toLowerCase() }}</h3>
                    <div class="m-2 mt-0">
                        <reviews :identifier="fitter.account_number" no-label></reviews>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <span class="d-inline-block badge rounded-pill bg-navy text-white mb-2 px-2" v-if="fitter.cal_account_number == 'CALFIT'">
                            <span class="five-star-badge"><i class="fal fa-tire fs-5 me-2"></i> Premium Fitter</span>
                        </span>
                        <span class="d-inline-block badge rounded-pill bg-warning text-dark mb-2 px-2" v-else-if="fitter.average_score == 5">
                            <span class="five-star-badge"><i class="fas fa-award fs-5 me-2"></i> 5 Star Fitter</span>
                        </span>
                        <b v-if="fitter.mobile == 0" class="fs-6 d-block text-navy">{{ parseFloat(fitter.distance, 2) }} miles</b>
                        <div class="opening-times text-navy">
                            <div class="d-block">
                                <b>Mon-Fri:</b><span>&nbsp;{{ fitter.weekday }}</span>
                            </div>
                            <div class="d-block" v-if="fitter.saturday != '00:00-00:00'">
                                <b>Sat:</b><span>&nbsp;{{ fitter.saturday }}</span>
                            </div>
                            <div class="d-block" v-if="fitter.sunday != '00:00-00:00'">
                                <b>Sun:</b><span>&nbsp;{{ fitter.sunday }}</span>
                            </div>
                        </div>
                        <div v-if="fitter.mobile == 0" class="fitter-address fs-6 mt-1">
                            <p><span class="text-capitalize">{{ fitter.address_line_one.toLowerCase() }}</span>, {{ fitter.postcode }}</p>
                        </div>
                        <div class="mobile-fitter-msg alert alert-warning p-2 my-2 mt-sm-4 mb-sm-0" v-else>
                            <p class="mb-0">Have one of our mobile fitters come to you from only <b>£{{ parseFloat(fitter.mobile_customer_surcharge).toFixed(2) }}</b> extra</p>
                        </div>
                        <div class="services" v-if="fitter.services.available.length > 0">
                            <b class="text-navy">Services available</b>
                            <ul class="list-unstyled">
                                <li v-for="service in fitter.services.available" class="text-navy"><i class="fa-solid fa-circle-check me-2 text-green"></i>{{ service.name }}</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <VeeForm v-slot="{ handleSubmit, errors }" as="div" class="col-12">
                            <form ref="fitterForm" @submit="handleSubmit($event, selectFitter)" method="post" :action="this.baseUrl + '/fitter-submit'" class="size-form">
                                <fitter-date-time
                                    :fitter="fitter"
                                    :mobile-fitting-slots="mobileFittingSlots"
                                    :errors="errors"
                                    :route="route"
                                    :update-fitting-time="true"
                                ></fitter-date-time>
                                <div class="col-12" v-if="fitter.mobile == 1 && fitter.cal_account_number != 'CALTOTD'">
                                    <p class="mb-0">The fitter will contact you with a fitting time estimate.</p>
                                </div>
                                <div class="col-12">
                                    <input type="hidden" name="fitter_id" :value="fitter.account_number"/>
                                    <button class="btn btn-primary form-control mt-2" :disabled="(fitter.cal_account_number == 'CALTOTD' && dateSelected == false ? true : false)" type="submit">
                                        Select this {{ fitter.mobile == 1 ? 'mobile' : 'garage' }} fitter
                                    </button>
                                </div>
                            </form>
                        </VeeForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Form as VeeForm, Field , ErrorMessage} from 'vee-validate';
    import * as yup from 'yup';

    export default {
        props: ['fitter', 'mapIcons', 'route', 'mobileFittingSlots', 'view'],
        components: {
            VeeForm,
            Field,
            ErrorMessage
        },
        data() {
            return {
                dateSelected: false,
                disabled: false,
                fiveStars: true,
                appDate: Object.keys(this.fitter?.fitting_days)[0],
                appTime: ((this.fitter?.mobile == 0 || this.fitter?.cal_account_number == 'CALTOTD') ? Object.keys(this.fitter?.fitting_times)[0] : '')
            }
        },
        mounted() {
            this.emitter.on('updateSelectedAppDate', data => {
                this.appDate = data;
            });

            this.emitter.on('updateSelectedAppTime', data => {
                this.appTime = data;
            });
        },
        methods: {
            getCustomFitterClass(cal_account_number) {
                if(cal_account_number == 'CALHALF') {
                    return 'halfords';
                }
                else if(cal_account_number == 'CALFIT') {
                    return 'protyre';
                }
                else if(cal_account_number == 'CALAAPRE') {
                    return 'aa-prestige';
                }
                else if(this.fitter.mobile == 0) {
                    return 'independant';
                }
                else if(this.fitter.mobile == 1) {
                    return 'mobile';
                }
            },
            highlightFitterOnMap() {
                this.emitter.emit('highlightFitterOnMap', this.fitter);
            },
            async selectFitter() {
                if(this.view == 'fittedNationally') {
                    var response = await axios.post('/ajax/fitter_modal_window/'+ this.fitter.account_number + '/' + this.appDate + '/' + this.appTime + '/' + this.fitter.distance + '/' + this.fitter.latitude + '/' + this.fitter.longitude);
                    
                    if(response) {
                        this.emitter.emit('openFitterModal', { fitter: this.fitter, sizeOptions: response.data.size_options, selectedAppDate: this.appDate, selectedAppTime: this.appTime, selectedFittingTimes: this.fitterTimes});
                    }
                }
                else {
                    this.emitter.emit('isLoading', true);
                    this.$refs.fitterForm.submit();
                }
            }
        },
        computed: {

        }
    }
</script>

<style lang="scss" scoped>
    .fitter {
        font-size: 14px;
        &.five-star {
            .card-header {
                background-color: #212121;
                h3 {
                    color: #fff !important;
                }
            }
        }
        .card-header {
            span {
                min-width: 35px;
                font-size: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #212121;
            }
            h3 {
                font-size: 18px;
                font-weight: 600;
            }
        }
        .card-body {
            .five-star-badge {
                font-size: 17px;
                display: flex;
                align-items: center;
                font-weight: 600;
            }
            .fitting-date {
                select {
                    max-width: 155px;
                    height: 40px;
                    font-size: 14px;
                }
            }
            .mobile-fitter-msg {
                text-align: center;
                color: #000;
            }
            .services {
                li {
                    float: left;
                    width: 100%;
                    margin-right: 20px;
                    i {
                        color: #38B577;
                    }
                }
            }
        }
    }
</style>